export default "__VITE_ASSET__fde5eabb__"